import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import Para from "@/components/atoms/text/Para";
import H2 from "@/components/atoms/text/H2";

export default function CookiePolicy() {
  const seoData = {
    indexing: true,
    title: "Cookie Policy | AnswerForce",
    description:
      "Learn more about our Cookies Policy. Read about what user data we track, how we use it to improve the visitor experience, and how we handle your data.",
    og: {
      title: "Cookie Policy | AnswerForce",
      description:
        "Learn more about our Cookies Policy. Read about what user data we track, how we use it to improve the visitor experience, and how we handle your data.",
      url: "/cookie-policy",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/cookiepolicy-og.jpg",
    },
    twitter: {
      title: "Cookie Policy | AnswerForce",
      description:
        "Learn more about our Cookies Policy. Read about what user data we track, how we use it to improve the visitor experience, and how we handle your data.",
      url: "/cookie-policy",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/cookiepolicy-og.jpg",
      image_alt: "AnswerForce",
    },
  };

  const firstPartyData = [
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "__utma",
      duration: "2 years",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "__utmc",
      duration: "7 months",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "__utmt",
      duration: "1 day",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "__utmz",
      duration: "6 months",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "_dc_gtm_UA-65573401-1",
      duration: "1 day",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "_ga",
      duration: "1 day",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "_gid",
      duration: "24 months",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "_hjIncludedInSample",
      duration: "2 days",
      purpose:
        "Google Analytics which help us measure<br className='desktop-only' /> how users interact with our website content.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "googleTagData",
      duration: "session",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "signupLink",
      duration: "12 months",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "isregistered",
      duration: "12 months",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "JSESSIONID",
      duration: "session",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "uniquePin",
      duration: "12 months",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "plan",
      duration: "session",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
    {
      domain: "www.answerforce.com",
      url: "/",
      isLink: true,
      name: "price_p",
      duration: "session",
      purpose:
        "Recognise you when you return to the site to<br className='desktop-only'/> increase the speed of your browsing.",
    },
  ];

  const thirdPartyData = [
    {
      domain: "hotjar.com",
      category: "third-party",
      url: "https://www.hotjar.com/",
      isLink: true,
      name: "__hstc",
      duration: "15 months",
      purpose:
        "Hotjar which helps us measure how users<br class='desktop-only' /> interact with our website content.",
    },
    {
      domain: "smartlook.com",
      category: "third-party",
      url: "https://www.smartlook.com/",
      isLink: true,
      name: "SL_C_23361d d035530_SID",
      duration: "13 months",
      purpose: "Smartlook measure how users interact with our website content.",
    },
    {
      domain: "smartlook.com",
      category: "third-party",
      url: "https://www.smartlook.com/",
      isLink: true,
      name: "SL_L_23361d d035530_SID",
      duration: "13 months",
      purpose: "Smartlook measure how users interact with our website content.",
    },
    {
      domain: "gstatic.com",
      category: "third-party",
      url: "/",
      isLink: false,
      name: "_ga",
      duration: "24 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "hotjar.com",
      category: "third-party",
      url: "https://www.hotjar.com/",
      isLink: true,
      name: "_ga",
      duration: "15 months",
      purpose:
        "Hotjar which helps us measure how users<br class='desktop-only' /> interact with our website content.",
    },
    {
      domain: "ipinfo.io",
      category: "third-party",
      url: "https://ipinfo.io/",
      isLink: true,
      name: "_ga",
      duration: "20 months",
      purpose:
        "Ipinfo which helps us deliver personalized<br class='desktop-only' /> content based on your geographical location.",
    },
    {
      domain: "gstatic.com",
      category: "third-party",
      url: "/",
      isLink: false,
      name: "_gid",
      duration: "2 days",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "1P_JAR",
      duration: "2 days",
      purpose:
        "Google Analytics which helps us measure how users interact with our website content.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "_hjIncludedInSample",
      duration: "1 day",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "APISID",
      duration: "24 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "facebook.com",
      category: "third-party",
      url: "https://www.facebook.com/",
      isLink: true,
      name: "fr",
      duration: "3 months",
      purpose:
        "Facebook which helps us understand how users interact with our website.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "HSID",
      duration: "3 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "hotjar.com",
      category: "third-party",
      url: "https://www.hotjar.com/",
      isLink: true,
      name: "hubspotutk",
      duration: "110 months",
      purpose:
        "Hotjar which helps us measure how users<br class='desktop-only' /> interact with our website content.",
    },
    {
      domain: "doubleclick.net",
      category: "third-party",
      url: "https://marketingplatform.google.com/about/enterprise/",
      isLink: true,
      name: "IDE",
      duration: "12 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "hotjar.com",
      category: "third-party",
      url: "https://www.hotjar.com/",
      isLink: true,
      name: "mp_hj_mixpanel",
      duration: "session",
      purpose:
        "Hotjar which helps us measure how users<br class='desktop-only' /> interact with our website content.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "NID",
      duration: "6 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "hotjar.com",
      category: "third-party",
      url: "https://www.hotjar.com/",
      isLink: true,
      name: "optimizelyBuckets",
      duration: "110 months",
      purpose:
        "Hotjar which helps us measure how users<br class='desktop-only' /> interact with our website content.",
    },
    {
      domain: "hotjar.com",
      category: "third-party",
      url: "https://www.hotjar.com/",
      isLink: true,
      name: "optimizelyEndUserId",
      duration: "110 months",
      purpose:
        "Hotjar which helps us measure how users<br class='desktop-only' /> interact with our website content.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "SAPISID",
      duration: "24 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "smartlook.com",
      category: "third-party",
      url: "https://www.smartlook.com/",
      isLink: true,
      name: "AWSELB cookie",
      duration: "13 months",
      purpose: "Smartlook measure how users interact with our website content.",
    },
    {
      domain: "smartlook.com",
      category: "third-party",
      url: "https://www.smartlook.com/",
      isLink: true,
      name: "SL_C_23361d d035530_DOMAIN",
      duration: "110 months",
      purpose: "Smartlook measure how users interact with our website content.",
    },
    {
      domain: "smartlook.com",
      category: "third-party",
      url: "https://www.smartlook.com/",
      isLink: true,
      name: "SMARTLOOK_LS_ QUEUED_CHUNKS",
      duration: "110 months",
      purpose: "Smartlook measure how users interact with our website content.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "SID",
      duration: "110 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "SIDCC",
      duration: "110 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
    {
      domain: "google.com",
      category: "third-party",
      url: "https://www.google.com/",
      isLink: true,
      name: "SSID",
      duration: "24 months",
      purpose:
        "Used by Google to store user preferences for better browsing experience.",
    },
  ];

  const generateTableRows = (tableData) => {
    return tableData.map((row, idx) => {
      return (
        <tr key={idx}>
          <td className="text--md pv-2 pl-4 pr-4">
            {row.isLink ? (
              row.category === "third-party" ? (
                <a href={row.url} target="_blank" rel="noopener noreferrer">
                  {row.domain}
                </a>
              ) : (
                <a href={row.url}>{row.domain}</a>
              )
            ) : (
              row.domain
            )}
          </td>
          <td className="text--md pv-2 pl-4 pr-4">{row.name}</td>
          <td className="text--md pv-2 pl-4 pr-4">{row.duration}</td>
          <td
            className="text--md pv-2 pl-4 pr-4"
            dangerouslySetInnerHTML={{ __html: row.purpose }}
          ></td>
          <style jsx>{`
            td {
              border: solid #9f9faf;
              border-width: 0 1px 1px 0;
              vertical-align: middle;
              word-wrap: break-word;
            }
            td:first-child {
              width: 26%;
            }
            td:nth-child(2) {
              width: 20%;
            }
            td:nth-child(3) {
              width: 14%;
            }
            td:last-child {
              min-width: 370px;
            }
            tr:last-child td:first-child {
              border-radius: 0 0 0 8px;
            }
            tr:last-child td:last-child {
              border-radius: 0 0 8px 0;
            }
          `}</style>
        </tr>
      );
    });
  };

  const hero = (
    <Hero
      heroTitle="Cookies Policy<span class='dot'>.</span>"
      variant="legalInfoPage"
    />
  );

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData} showBanner={false}>
      <section className="cookie-policy pt-7 pb-10 pv-15-d">
        <div className="container">
          <article>
            <Para mobileSize="md" className="mb-3">
              A 'cookie' is a small text file that is downloaded onto your
              Access Device when you visit a website and that enables the
              website to obtain certain information from your browser, such as
              your preferences. Cookies allow us to maximize your experience
              using the Website by increasing its functionality and allowing the
              Website to remember information and selections as you move from
              page to page and from visit to visit, depending on the cookie. A
              cookie does not harm Your Access Device nor does it contain any
              viruses or other malware.
            </Para>
            <Para mobileSize="md" className="mb-3">
              The Site uses cookies to distinguish you from other users of the
              Site. This helps us to provide you with a good experience when you
              browse the Site and also allows us to improve the Site. By
              continuing to browse the Site, you are agreeing to our use of
              cookies.
            </Para>
            <Para mobileSize="md" className="mb-3">
              We use the following cookies:
            </Para>
            <ul className="bullet-list pl-5">
              <li className="text--md mb-2-d">
                Strictly necessary cookies. These are cookies that are required
                for the operation of the Site. They include, for example,
                cookies that enable you to log into secure areas of the Site or
                make use of e-billing services.
              </li>
              <li className="text--md mb-2-d">
                Analytical/performance cookies. They allow us to recognise and
                count the number of visitors and to see how visitors move around
                the Site when they are using it. This helps us to improve the
                way the Site works, for example, by ensuring that users are
                finding what they are looking for easily.
              </li>
              <li className="text--md mb-2-d">
                Functionality cookies. These are used to recognise you when you
                return to the Site. This enables us to personalise our content
                for you, greet you by name and remember your preferences (for
                example, your choice of language or region).
              </li>
              <li className="text--md mb-2-d mb-3">
                Targeting cookies. These cookies record your visit to the Site,
                the pages you have visited and the links you have followed. We
                will use this information to make the Site and the advertising
                displayed on it more relevant to your interests. We may also
                share this information with third parties for this purpose.
              </li>
            </ul>
            <Para mobileSize="md">
              You can find more information about the individual cookies we use
              and the purposes for which we use them in the table below:
            </Para>
          </article>
          <article className="pt-8-d pt-7">
            <H2 desktopSize="xs" mobileSize="xs" className="mb-5">
              First-party cookies<span className="dot">.</span>
            </H2>
            <div className="table-wrapper">
              <table width="100%" cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Domain
                    </th>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Name
                    </th>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Duration
                    </th>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Purpose
                    </th>
                  </tr>
                </thead>
                <tbody>{generateTableRows(firstPartyData)}</tbody>
              </table>
            </div>
          </article>
          <article className="pt-8">
            <H2 desktopSize="xs" mobileSize="xs" className="mb-5">
              Third-party cookies<span className="dot">.</span>
            </H2>
            <Para mobileSize="md" className="mb-5">
              Please note that third parties (including, for example,
              advertising networks and providers of external services like web
              traffic analysis services) may also use cookies, over which we
              have no control. These cookies are likely to be
              analytical/performance cookies or targeting cookies.
            </Para>
            <div className="table-wrapper">
              <table width="100%" cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Domain
                    </th>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Name
                    </th>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Duration
                    </th>
                    <th className="text--md bold ta-left pv-2 pl-4 pr-4">
                      Purpose
                    </th>
                  </tr>
                </thead>
                <tbody>{generateTableRows(thirdPartyData)}</tbody>
              </table>
            </div>
            <Para mobileSize="md" className="mt-5">
              You block cookies by activating the setting on your browser that
              allows you to refuse the setting of all or some cookies. However,
              if you use your browser settings to block all cookies (including
              essential cookies) you may not be able to access all or parts of
              the Site.
            </Para>
          </article>
          <article className="pt-8-d pt-7">
            <H2 desktopSize="xs" mobileSize="xs" className="mb-5-d mb-3">
              Manage your cookies<span className="dot">.</span>
            </H2>
            <Para mobileSize="md" className="mb-5">
              Please note that third parties (including, for example,
              advertising networks and providers of external services like web
              traffic analysis services) may also use cookies, over which we
              have no control. These cookies are likely to be
              analytical/performance cookies or targeting cookies.
            </Para>
            <ul className="pl-5 mb-8-d mb-7 browser-list bullet-list">
              <li className="text--md">
                <a
                  className="text--link"
                  href="https://support.google.com/chrome/answer/95647?hl=en-GB"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chrome
                </a>
              </li>
              <li className="text--md">
                <a
                  className="text--link"
                  href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Safari
                </a>
              </li>
              <li className="text--md">
                <a
                  className="text--link"
                  href="https://support.mozilla.org/kb/how-do-i-turn-do-not-track-feature"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Firefox
                </a>
              </li>
              <li className="text--md">
                <a
                  className="text--link"
                  href="https://support.microsoft.com/hub/4230784/internet-explorer-help#ie=ie-11"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Internet Explorer
                </a>
              </li>
            </ul>
            <H2 desktopSize="xs" mobileSize="xs" className="mb-5">
              Contact<span className="dot">.</span>
            </H2>
            <Para mobileSize="md">
              For questions or concerns, please contact us at{" "}
              <a
                className="text--link"
                href="mailto:customercare@answerforce.com"
              >
                customercare@answerforce.com
              </a>
            </Para>
          </article>
        </div>
        <style jsx>{`
          .cookie-policy .container {
            max-width: 1020px;
          }
          .cookie-policy .browser-list li::marker {
            color: #3270d8;
          }
          .cookie-policy .text--link {
            border-bottom: 0;
          }
          .table-wrapper {
            overflow-x: auto;
          }
          .table-wrapper::-webkit-scrollbar {
            display: none;
          }
          table {
            border-collapse: separate;
            border: solid #9f9faf;
            border-width: 1px 0 0 1px;
            border-radius: 8px;
          }
          table th,
          table td {
            border: solid #9f9faf;
            border-width: 0 1px 1px 0;
            vertical-align: middle;
            word-wrap: break-word;
          }
          table th:last-child {
            border-radius: 0 8px 0 0;
          }
        `}</style>
      </section>
    </Theme>
  );
}
